import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
// Layouts
import RootLayout from "../layouts/root-layout/RootLayout";
// Pages
import Home from "../pages/home/Home";
import Services from "../pages/services/Services";
import SocialMediaCreatives from "../pages/social-media-creatives/SocialMediaCreatives";
import About from "../pages/about/About";
import ContactUs from "../pages/contact-us/ContactUs";
import Works from "../pages/works/Works";
import WorkHyundai from "../pages/work-pages/work-hyundai/WorkHyundai";
import WorkMobu from "../pages/work-pages/work-mobu/WorkMobu";
import WorkGenie from "../pages/work-pages/work-genie/WorkGenie";
import WorkWooords from "../pages/work-pages/work-wooords/WorkWooords";
import WorkFahrlygo from "../pages/work-pages/work-fahrlygo/WorkFahrlygo";
import WorkCrypto from "../pages/work-pages/work-crypto/WorkCrypto";
import WorkVittaverse from "../pages/work-pages/work-vittaverse/WorkVittaverse";
import WorkUpgaming from "../pages/work-pages/work-upgaming/WorkUpgaming";
import WorkNespola from "../pages/work-pages/work-nespola/WorkNespola";
import WorkBenefits from "../pages/work-pages/work-benefits/WorkBenefits";
import CoreUxDesign from "../pages/blog-pages/core-ux-design/CoreUxDesign";
import CompleteSeo from "../pages/blog-pages/complete-seo/CompleteSeo";
import WebsiteManagement from "../pages/blog-pages/website-management/WebsiteManagement";
import UserInterfaceDesign from "../pages/blog-pages/user-interface-design/UserInterfaceDesign";
import BrandIdentity from "../pages/blog-pages/brand-identity/BrandIdentity";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<RootLayout />}>
        <Route index element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route
          path="/services/social-media-creatives"
          element={<SocialMediaCreatives />}
        />
        <Route path="/about" element={<About />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/our-work" element={<Works />} />
        {/* Work Pages */}
        <Route path="/work/hyundai" element={<WorkHyundai />} />
        <Route path="/work/mobu" element={<WorkMobu />} />
        <Route path="/work/genie" element={<WorkGenie />} />
        <Route path="/work/wooords" element={<WorkWooords />} />
        <Route path="/work/fahrlygo" element={<WorkFahrlygo />} />
        <Route path="/work/crypto" element={<WorkCrypto />} />
        <Route path="/work/vittaverse" element={<WorkVittaverse />} />
        <Route path="/work/upgaming" element={<WorkUpgaming />} />
        <Route path="/work/nespola" element={<WorkNespola />} />
        <Route path="/work/benefits" element={<WorkBenefits />} />
        <Route path="/work/*" element={<Works />} />
        <Route path="/*" element={<ContactUs />} />
        {/* Blog Pages */}
        <Route path="blog/core-ux-design" element={<CoreUxDesign />} />
        <Route path="blog/complete-seo-for-websites" element={<CompleteSeo />} />
        <Route path="blog/what-is-website-management" element={<WebsiteManagement />} />
        <Route path="blog/user-interface-design" element={<UserInterfaceDesign />} />
        <Route path="blog/what-is-brand-identity" element={<BrandIdentity />} />
      </Route>
    </>
  )
);
